import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const bookings = [
  { name: 'Mike T.', city: 'Dallas, TX', tickets: 3 },
  { name: 'Sarah K.', city: 'Toronto, ON', tickets: 2 },
  { name: 'The Williams Family', city: 'Phoenix, AZ', tickets: 5 },
  { name: 'Emily R.', city: 'Vancouver, BC', tickets: 2 },
  { name: 'Carlos & Ana M.', city: 'Miami, FL', tickets: 2 },
  { name: 'Jennifer L.', city: 'Calgary, AB', tickets: 4 },
  { name: 'David P.', city: 'Chicago, IL', tickets: 1 },
  { name: 'The Johnson Group', city: 'Atlanta, GA', tickets: 8 },
  { name: 'Lisa & Mark H.', city: 'Seattle, WA', tickets: 2 },
  { name: 'Rachel F.', city: 'Montreal, QC', tickets: 3 },
  { name: 'Kevin S.', city: 'Houston, TX', tickets: 2 },
  { name: 'Amanda & Josh W.', city: 'Denver, CO', tickets: 2 },
];

const SocialProof = () => {
  const shown = useRef(new Set());

  useEffect(() => {
    const showNotification = () => {
      const available = bookings.filter((_, i) => !shown.current.has(i));
      if (available.length === 0) shown.current.clear();

      const pool = available.length > 0 ? available : bookings;
      const idx = bookings.indexOf(pool[Math.floor(Math.random() * pool.length)]);
      shown.current.add(idx);
      const b = bookings[idx];

      toast(`${b.name} from ${b.city}`, {
        description: `Just booked ${b.tickets} ticket${b.tickets > 1 ? 's' : ''} for the Hollywood tour!`,
        duration: 5000,
        position: 'bottom-left',
      });
    };

    const first = setTimeout(showNotification, 10000);
    const interval = setInterval(showNotification, 20000);

    return () => {
      clearTimeout(first);
      clearInterval(interval);
    };
  }, []);

  return null;
};

export default SocialProof;
